module.exports = __webpack_public_path__ + "img/xactus-logo-intelligent.87669790.svg";